import { datadogRum } from "@datadog/browser-rum";
import * as Sentry from "@sentry/browser";

export function trackLocalStorage() {
  Sentry.startSpan(
    {
      name: "Measure size of localStorage",
      op: "localStorage",
    },
    async (span) => {
      try {
        const encoder = new TextEncoder();
        const size = encoder.encode(JSON.stringify(localStorage)).byteLength;
        span.setAttribute("localStorage.size", size);
        datadogRum.addAction("localStorage.size", {
          size,
        });
      } catch (err) {
        Sentry.captureException(err);
      }
    }
  );
}
